<!-- Completar perfil de empresa — post OAuth -->
<div class="tw-min-h-screen tw-bg-gradient-to-br tw-from-slate-900 tw-via-blue-950 tw-to-indigo-950 tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-16">

  <div class="tw-w-full tw-max-w-2xl">

    <!-- Header -->
    <div class="tw-text-center tw-mb-10">
      <a routerLink="/">
        <img src="assets/img/logo.png" alt="TecGurus Empleos" class="tw-h-14 tw-mx-auto">
      </a>

      <!-- Step badge -->
      <div class="tw-mt-6 tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-1.5 tw-rounded-full tw-bg-brand-500/20 tw-border tw-border-brand-500/30 tw-text-brand-300 tw-text-xs tw-font-semibold tw-tracking-wide tw-uppercase">
        <svg class="tw-w-3.5 tw-h-3.5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd"/>
        </svg>
        Casi listo — paso 2 de 2
      </div>

      <h1 class="tw-mt-4 tw-text-3xl tw-font-bold tw-text-white">Cuéntanos sobre tu empresa</h1>
      <p class="tw-mt-2 tw-text-slate-400 tw-text-sm tw-max-w-md tw-mx-auto">
        Necesitamos estos datos para que puedas publicar vacantes y acceder a candidatos tech calificados.
      </p>
    </div>

    <!-- Card -->
    <div class="tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-p-8">

      <form [formGroup]="form" (ngSubmit)="guardar()" novalidate>

        <!-- 2-col grid -->
        <div class="tw-grid tw-grid-cols-1 tw-gap-5 sm:tw-grid-cols-2">

          <!-- Nombre comercial -->
          <div>
            <label class="tw-block tw-text-sm tw-font-semibold tw-text-slate-700 tw-mb-1.5">
              Nombre comercial <span class="tw-text-red-500">*</span>
            </label>
            <input type="text" formControlName="nombreComercial"
                   placeholder="Ej. TecGurus Consulting"
                   class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none
                          focus:tw-ring-2 focus:tw-ring-brand-500/30 focus:tw-border-brand-500 tw-transition">
            <div *ngIf="form.controls.nombreComercial.invalid && form.controls.nombreComercial.touched"
                 class="tw-mt-1 tw-text-xs tw-text-red-500">Campo requerido.</div>
          </div>

          <!-- Razón social -->
          <div>
            <label class="tw-block tw-text-sm tw-font-semibold tw-text-slate-700 tw-mb-1.5">
              Razón social <span class="tw-text-red-500">*</span>
            </label>
            <input type="text" formControlName="razonSocial"
                   placeholder="Ej. TecGurus S.A. de C.V."
                   class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none
                          focus:tw-ring-2 focus:tw-ring-brand-500/30 focus:tw-border-brand-500 tw-transition">
            <div *ngIf="form.controls.razonSocial.invalid && form.controls.razonSocial.touched"
                 class="tw-mt-1 tw-text-xs tw-text-red-500">Campo requerido.</div>
          </div>

          <!-- RFC -->
          <div>
            <label class="tw-block tw-text-sm tw-font-semibold tw-text-slate-700 tw-mb-1.5">
              RFC <span class="tw-text-red-500">*</span>
            </label>
            <input type="text" formControlName="rfc" maxlength="14"
                   placeholder="TGC200101ABC"
                   class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none
                          focus:tw-ring-2 focus:tw-ring-brand-500/30 focus:tw-border-brand-500 tw-transition tw-uppercase">
            <div *ngIf="form.controls.rfc.invalid && form.controls.rfc.touched"
                 class="tw-mt-1 tw-text-xs tw-text-red-500">RFC requerido (12-14 caracteres).</div>
          </div>

          <!-- Giro -->
          <div>
            <label class="tw-block tw-text-sm tw-font-semibold tw-text-slate-700 tw-mb-1.5">
              Giro empresarial <span class="tw-text-red-500">*</span>
            </label>
            <input type="text" formControlName="giroEmpresarial"
                   placeholder="Ej. Desarrollo de Software"
                   class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none
                          focus:tw-ring-2 focus:tw-ring-brand-500/30 focus:tw-border-brand-500 tw-transition">
            <div *ngIf="form.controls.giroEmpresarial.invalid && form.controls.giroEmpresarial.touched"
                 class="tw-mt-1 tw-text-xs tw-text-red-500">Campo requerido.</div>
          </div>

          <!-- Teléfono -->
          <div>
            <label class="tw-block tw-text-sm tw-font-semibold tw-text-slate-700 tw-mb-1.5">
              Teléfono <span class="tw-text-red-500">*</span>
            </label>
            <input type="tel" formControlName="telefono"
                   placeholder="5512345678"
                   class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none
                          focus:tw-ring-2 focus:tw-ring-brand-500/30 focus:tw-border-brand-500 tw-transition">
            <div *ngIf="form.controls.telefono.invalid && form.controls.telefono.touched"
                 class="tw-mt-1 tw-text-xs tw-text-red-500">Teléfono requerido.</div>
          </div>

          <!-- Dirección -->
          <div>
            <label class="tw-block tw-text-sm tw-font-semibold tw-text-slate-700 tw-mb-1.5">
              Dirección <span class="tw-text-slate-400 tw-font-normal tw-text-xs">(opcional)</span>
            </label>
            <input type="text" formControlName="direccion"
                   placeholder="Calle y número, colonia"
                   class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none
                          focus:tw-ring-2 focus:tw-ring-brand-500/30 focus:tw-border-brand-500 tw-transition">
          </div>

          <!-- País -->
          <div class="sm:tw-col-span-2">
            <label class="tw-block tw-text-sm tw-font-semibold tw-text-slate-700 tw-mb-1.5">
              País <span class="tw-text-red-500">*</span>
            </label>
            <select formControlName="pais"
                    class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none tw-bg-white
                           focus:tw-ring-2 focus:tw-ring-brand-500/30 focus:tw-border-brand-500 tw-transition">
              <option value="">Selecciona un país</option>
              <option *ngFor="let p of paises" [value]="p.nombre">{{ p.nombre }}</option>
            </select>
            <div *ngIf="form.controls.pais.invalid && form.controls.pais.touched"
                 class="tw-mt-1 tw-text-xs tw-text-red-500">Selecciona un país.</div>
          </div>

        </div>

        <!-- Error -->
        <div *ngIf="error"
             class="tw-mt-5 tw-flex tw-items-start tw-gap-2 tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200">
          <svg class="tw-w-4 tw-h-4 tw-text-red-500 tw-mt-0.5 tw-shrink-0" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd"/>
          </svg>
          <p class="tw-text-sm tw-text-red-600">{{ error }}</p>
        </div>

        <!-- Submit -->
        <button type="submit" [disabled]="enviando"
                class="tw-mt-6 tw-w-full tw-py-3 tw-rounded-xl
                       tw-bg-gradient-to-r tw-from-brand-600 tw-to-indigo-600
                       hover:tw-from-brand-700 hover:tw-to-indigo-700
                       tw-text-white tw-font-semibold tw-text-sm tw-transition tw-duration-200
                       tw-shadow-lg hover:tw-shadow-brand-500/25 hover:tw-shadow-xl
                       disabled:tw-opacity-60 disabled:tw-cursor-not-allowed">
          <span *ngIf="!enviando" class="tw-flex tw-items-center tw-justify-center tw-gap-2">
            Completar perfil y acceder
            <svg class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"/>
            </svg>
          </span>
          <span *ngIf="enviando" class="tw-flex tw-items-center tw-justify-center tw-gap-2">
            <svg class="tw-w-4 tw-h-4 tw-animate-spin" fill="none" viewBox="0 0 24 24">
              <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
            </svg>
            Guardando…
          </span>
        </button>

      </form>
    </div>

    <!-- Footer -->
    <p class="tw-text-center tw-mt-5 tw-text-sm tw-text-slate-500">
      ¿No eres una empresa?
      <a routerLink="/acceder" class="tw-font-semibold tw-text-brand-400 hover:tw-text-brand-300">
        Volver al inicio de sesión
      </a>
    </p>

  </div>
</div>
